{
    "welcome-to": "Vítejte v",
    "copyright": "Autorská práva",
    "trademarks": "Všechny ochranné známky nebo registrované ochranné známky jsou majetkem jejich příslušných vlastníků.",

    "menu-profile": "Profil",
    "menu-logout": "Odhlásit se",
    "menu-home": "Domů",
    "menu-dashboard": "Přehled",
    "menu-machines": "Stroje",
    "menu-colaboration": "Spolupráce",
    "menu-administration": "Administrace",
    "menu-machine": "Stroj",
    "menu-list": "Seznam",
    "menu-service-data": "Servisní data",
    "menu-trash": "Koš",

    "machine-info": "Informace o stroji",
    "medium": "Médium",
    "machine-activity": "Aktivita stroje",
    "machine-part-info": "Informace o části stroje",
    "name": "Název",
    "version": "Verze",
    "owner": "Vlastník",
    "state": "Stav",
    "actions": "Akce",
    "kind": "Druh",
    "description": "Popis",
    "size": "Velikost",
    "last-write": "Poslední zápis",
    "ver": "Ver.",
    "restore": "Obnovit",
    "when": "Kdy",
    "type": "Typ",
    "level": "Úroveň",
    "text": "Text",
    "tags": "Štítky",
    "part-type": "Typ části",
    "firmware-version": "Verze firmwaru",
    "model": "Model",
    "created": "Vytvořeno",
    "modified": "Upraveno",
    "status": "Stav",
    "loading": "Načítání",
    "fv": "F.v.",
    "remove": "Odstranit",
    "user": "Uživatel",
    "fenix-version": "Verze Fenix",
    "service-data-remove-question": "Opravdu chcete tato servisní data smazat?",
    "save-as-duplicate": "Uložit jako duplikát",
    "upload-file": "Nahrát soubor",
    "restore-machine-data-from-backup": "Obnovit data stroje ze zálohy",
    "you-want-to-change-owner": "Chcete změnit vlastníka?",
    "choose-file": "Vybrat soubor",
    "detail": "Detail",
    "yes": "Ano",
    "no": "Ne",
    "machine-detail-remove-question": "Opravdu chcete tento stroj smazat?",
    "status-auto-update": "Automatická aktualizace stavu",
    "download": "Stáhnout",
    "copy": "Kopírovat",
    "move": "Přesunout",
    "change-owner": "Změnit vlastníka",
    "new-machine-name": "Nový název stroje",
    "submit": "Odeslat",
    "set-as-current": "Nastavit jako aktuální",
    "checkout": "Pokladna",
    "base-data": "Základní data",
    "part-structure-type": "Typ struktury části",
    "owner-id": "ID vlastníka",
    "parent-id": "ID rodiče",
    "part-class-type": "Typ třídy části",
    "errors": "Chyby",
    "generic-device": "Obecné zařízení",
    "device-model": "Model zařízení",
    "address": "Adresa",
    "camera-info": "Informace o kameře",
    "sensor-model": "Model senzoru",
    "slides-in-view": "Snímky v zobrazení",
    "slider-info": "Informace o posuvníku",
    "channels": "Kanály",
    "shot-stats-from": "Statistiky snímků od",
    "shot-stats-to": "Statistiky snímků do",
    "shot-stats-counter": "Počítadlo statistik snímků",
    "shot-stats": "Statistiky snímků",
    "slider": "Posuvník",
    "valve": "Ventil",
    "number-shots": "Počet snímků",
    "custom": "Vlastní",
    "move-machine": "Přesunout stroj",
    "machine-is-not-selected": "Stroj není vybrán.",
    "machine-successfully-deleted": "Stroj byl úspěšně smazán.",
    "failed-to-delete-machine": "Nepodařilo se smazat stroj.",
    "failed-to-backup-machine": "Nepodařilo se zálohovat stroj.",
    "owner-successfully-changed": "Vlastník byl úspěšně změněn.",
    "failed-to-change-owner": "Nepodařilo se změnit vlastníka.",
    "machine-successfully-copied": "Stroj byl úspěšně zkopírován.",
    "failed-to-copy-machine": "Nepodařilo se zkopírovat stroj.",
    "machine-successfully-moved": "Stroj byl úspěšně přesunut.",
    "failed-to-move-machine": "Nepodařilo se přesunout stroj.",
    "machine-set-as-current": "Stroj byl nastaven jako aktuální.",
    "install-app-question": "Chcete nainstalovat aplikaci 3U Vision Cloud?",
    "install": "Instalovat",
    "cancel": "Zrušit",
    "install-application": "Nainstalovat aplikaci",
    "step": "Krok",
    "tap-share-icon": "Klepněte na ikonu sdílení.",
    "scroll-down-and-tap": "V nabídce sdílení sjeďte dolů a klepněte",
    "add-to-home-screen": "Přidat na domovskou obrazovku",
    "you-will-be-propted": "Budete vyzváni k pojmenování aplikace. Můžete ponechat výchozí název nebo jej změnit podle potřeby. Pak klepněte na",
    "add": "Přidat",
    "in-top-right-corner": "v pravém horním rohu",
    "do-not-show-again": "Znovu nezobrazovat",
    "you-are-offline": "Jste offline.",
    "app-can-not-work-offline": "Aplikace nemůže pracovat offline.",
    "please-check-your-internet-connection": "Zkontrolujte prosím své internetové připojení.",
    "unexpected-server-version": "Neočekávaná verze serveru.",
    "current-is": "Aktuální je",
    "and-expected": "a očekávaný",
    "application-version-is": "Verze aplikace je",
    "new-version-available": "Nová verze je k dispozici",
    "do-you-want-to-install": "Chcete nainstalovat?",
    "delete-confirmation": "Potvrzení smazání",
    "machine-medium-remove-question": "Opravdu chcete smazat médium?",
    "machine-medium-checkout-error": "Nepodařilo se odhlásit médium stroje.",
    "invalid-data": "Neplatná data.",
    "failed-to-load-messages": "Nepodařilo se načíst zprávy.",
    "failed-to-save-board": "Nepodařilo se uložit desku.",
    "failed-to-delete-board": "Nepodařilo se smazat desku.",
    "machine-structure-caption": "Struktura",
    "machine-structure-value-caption": "Hodnota",
    "machine-structure-not-available" : "Konstrukce stroje není k dispozici",
    "machines-upload-file-upload-in-progress": "Probíhá nahrávání souboru.",
    "upload-success": "Nahrání proběhlo úspěšně."
  }
